module.exports = __webpack_public_path__ + "static/wtb-logo-61e981f3b89dbba69842cce5c6182d28.png";